import PropTypes from 'prop-types';

const Content = ({ children, stickyStyle }) => {
  if (typeof children === 'function') {
    return children({ stickyStyle });
  } else {
    return children;
  }
};

Content.displayName = 'Page.Content';
Content.propTypes = {
  /** Accept single or multiple compound <Cell/> elements which store content items. Other nodes are accepted but not recommended. */
  children: PropTypes.node.isRequired,

  /** Specifies a CSS class name to be appended to the component’s root element. */
  className: PropTypes.string,

  /** Stretches the component to a full screen mode */
  fullScreen: PropTypes.bool,
};
export default Content;
